/**
 * Griglia dell'interfaccia di bordo macchina.
 *
 * Posizioni originarie dal mockup del cliente (foglio INTERFACCIA di `Modifiche20260722.xlsx`,
 * disegnato con i bordi delle celle di Excel, colonne 3-18 → qui 16 colonne uguali), riviste
 * dopo una seconda call col cliente il 30/07/2026 (vedi `update/20260730/piano-modifiche.md`):
 * numero ordine spostato dalla riga 3 alla riga 1 (sempre visibile), "cambia stato" rimosso
 * dalla riga 2 (gestito solo da FERMO/AVVIO), quantità versata spostata nel pannello quantità.
 * Un secondo giro di feedback lo stesso giorno (screenshot pwa4.png) ha eliminato del tutto la
 * riga 3, spostando apertura/chiusura ordine dentro la riga 2, per recuperare spazio verticale
 * sul tablet 10.1": ora sono 4 righe invece di 5.
 *
 *   riga 1  [1-5 nome macchina] [7-9 stato attuale] [11-13 nr. ordine] [14-15 data/ora] [16 impostazioni]
 *   riga 2  [1-4 operatori]     [11-12 velocità settata]     [14-16 apertura/chiusura ordine]
 *   riga 3  [1-8 pannello quantità: ordinata+versata+scarti, rigetta+storico, versa+storico]
 *           [9-16 pannello velocità: attuale, campo+conferma+storico]
 *   riga 4  [1-7 FERMO]                             [9-16 AVVIO]
 *
 * Cambiare queste posizioni significa scostarsi da quanto concordato col cliente.
 */
export const GRID_16 = 'grid grid-cols-[repeat(16,minmax(0,1fr))] gap-3';

export const at = (start: number, span: number) => ({ gridColumn: `${start} / span ${span}` });
